import ShowBooleanAsIcon from "./ShowBooleanAsIcon";

export default ShowBooleanAsIcon;
